<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>180-617-517-75
          <span class="glyphicon glyphicon-envelope"></span>inssec@inssec.cn
          <span class="glyphicon glyphicon-time"></span>8:30-24:00
        </div>
        <div class="shejiao pull-right" hidden="true">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png">
      </div>
      <!-- 导航内容 -->
      <!-- <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul> -->
   <div class="menu">   
  <el-menu  :default-active="activeIndex" text-color="#4CAF50" background-color="#F4F4F4" class="header-nav-wrapper" mode="horizontal" @select="handleSelect">
  <el-menu-item index="/home">首页</el-menu-item>
  <el-submenu index="2">
    <template slot="title">产品中心</template>
    <el-submenu index="/basesoftware">
      <template slot="title">基础安全产品</template>
      <el-menu-item index="/basesoftware/model">芯片密码模块</el-menu-item>
      <el-menu-item index="/basesoftware/card">PCIe 密码卡</el-menu-item>
      <el-menu-item index="/basesoftware/soft">讯石安全盾</el-menu-item>
      <el-menu-item index="/basesoftware/sdk">SDK 开发工具</el-menu-item>
    </el-submenu>
     <el-submenu index="/software">
      <template slot="title">应用安全产品</template>
      <el-menu-item index="/software/tucp">终端接入鉴权与统一管控平台 TUCP</el-menu-item>
      <el-menu-item index="/software/system">SM2标识密钥管理系统 IPKKMS</el-menu-item>
      <!-- <el-menu-item index="/software/shield">NB窄带安全通信模组产品 M1000</el-menu-item> -->
      <el-menu-item index="/software/terminal">即插即用数据加密传输终端 SEU</el-menu-item>
      <el-menu-item index="/software/gateway">WIFI无线网络隔离认证设备 W-SCE</el-menu-item>
      <el-menu-item index="/software/database">数据库授权及加密存储系统 DEAS</el-menu-item>
    </el-submenu>
     <el-submenu index="/protocolSoftware">
      <template slot="title">协议层安全产品</template>
      <el-menu-item index="/protocolSoftware/shield">NB窄带安全通信模组产品 M1000</el-menu-item>
      <el-menu-item index="/protocolSoftware/svpn">微安全内核 SVPN</el-menu-item>
    </el-submenu>
  </el-submenu>
  <el-menu-item index="/service">解决方案</el-menu-item>
  <el-menu-item index="/companyintroduction">关于我们</el-menu-item>
  <!-- <el-menu-item index="/contactus">联系我们</el-menu-item> -->
  <el-menu-item index="6"><a href="https://test.inssaas.cn/kmskey/#/login" target="_blank">TUCP平台登录</a></el-menu-item>
  </el-menu>
  </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      activeIndex: '/home',
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "基础安全产品",
          path: "/basesoftware"
          // children: [
          //    /*基础安全产品 */
          //       {
          //           path: '/basesoftware',
          //           name: '基础安全产品',
          //       },
          //       /*应用安全产品 */
          //       {
          //           path: '/software',
          //           name: '应用安全产品',
          //       },
          //       // {
          //       //     path: '/software/system',
          //       //     name: 'IPK 轻量级密钥管理系统'
          //       // },{
          //       //     path: '/software/shield',
          //       //     name: 'NB窄带安全通信模组产品 M1000'
          //       // }
          //       // ,{
          //       //     path: '/software/terminal',
          //       //     name: '即插即用数据加密传输终端 SEU'
          //       // }
          //       // ,{
          //       //     path: '/software/gateway',
          //       //     name: 'WIFI无线网络隔离认证设备 W-SCE'
          //       // }
          //       // ,{
          //       //     path: '/software/database',
          //       //     name: '数据库授权及加密存储系统 DEAS'
          //       // }
               
          // ]
        },
        {
          name: "应用安全产品",
          path: "/software"
        },
        {
          name: "协议层安全产品",
          path: "/protocolSoftware"
        },
        {
          name: "解决方案",
          path: "/service",
          children: []
        },
        {
          name: "关于我们",
          path: "/companyintroduction",
          children: [
        // 
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
          ]
        },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // },
        {
          name: "TUCP平台登录",
          path: "",
          children: []
        },
        // {
        //   name: "技术交流",
        //   path: "/technology",
        //   children: [
        //     {
        //             path: '/technology/IPK1',
        //             name: 'IPK标识技术'
        //         },
        //         {
        //             path: '/technology/IPK2',
        //             name: '区块链应用'
        //       }
        //   ]
        // },
      ]
    };
  },
  methods: {
     handleSelect(key, keyPath) {
        this.$router.push(key)
      },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
      if(name == 'TUCP平台登录'){
        window.open("https://test.inssaas.cn/tucp/#/login");
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped lang="less">
/deep/.el-submenu__title {
  font-size: 14px;
  font-weight: bold;
}
</style>
<style scoped>
.el-menu-item {
  font-size: 14px;
  font-weight: bold;
}
.menu{
  height: 100px;
  display: flex;
}
a {
    color: #4CAF50!important;
    text-decoration: none;
}
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 100px;
  position: relative;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  /* width: 100px; */
  height: 100%;
  float: left;
  margin: auto;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 266.4px;
  position: relative;
  top: 15px;
  /* height: 99px; */
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 100px;
  /* float: right; */
  margin: 0;
  width: 800px;
  max-width: 800px;
  overflow: hidden;
  padding-top: 24px;
  margin-left: 50px;
  /* display: hidden; */
  /* position: absolute;
  left: 1400px; */
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #4CAF50;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #4CAF50;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be!important;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be!important;
  text-decoration: none;
  border-bottom: 2px solid #4CAF50;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 70px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    /* width: 95px; */
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue